import React from "react";
import PropTypes from "prop-types";
import { getChannelConfig } from "./messageCenterHelpers";
import styles from "./ChannelBadge.module.css";

/**
 * Badge de canal: ícone + label sobre a cor específica da plataforma
 * (whatsapp / instagram / widget). Cores vêm de `CHANNEL_COLORS`.
 *
 * `compact` exibe só o ícone (usado em espaços apertados).
 */
export default function ChannelBadge({ platform, compact = false }) {
  const { label, icon, background } = getChannelConfig(platform);

  return (
    <span
      className={`${styles.badge} ${compact ? styles.compact : ""}`}
      style={{ background }}
      title={label}
    >
      <span aria-hidden="true">{icon}</span>
      {!compact && <span className={styles.label}>{label}</span>}
    </span>
  );
}

ChannelBadge.propTypes = {
  platform: PropTypes.string,
  compact: PropTypes.bool,
};
